import React, { useMemo } from 'react';
import PersonIcon from '@mui/icons-material/Person';

import { EditUserModal } from '@components';

import InstaTaskSideBar from 'components/common/InstaTaskSideBar/InstaTaskSideBar';

import UserDetailsSidebarStatus from './UserDetailsSidebarStatus';
import { USER_DETAILS_TITLE, USER_DETAILS_MAPPER } from './constants';

const UserDetailsSidebar = ({ details, getUser, loading }) => {
  const sideBarTitle = USER_DETAILS_TITLE;

  const sidebarSections = useMemo(
    () => [
      {
        key: 'general',
        title: sideBarTitle,
        action: (
          <EditUserModal
            details={details}
            getUser={getUser}
            loading={loading}
          />
        ),
        subTitle: <UserDetailsSidebarStatus details={details} />,
        items: [
          {
            id: USER_DETAILS_MAPPER.id.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.id.sideBarLabel,
            value: details?.id || '-',
            showCopyValue: true,
          },
          {
            id: USER_DETAILS_MAPPER.internalId.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.internalId.sideBarLabel,
            value: details?.internalId || '-',
          },
          {
            id: USER_DETAILS_MAPPER.addressName.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.addressName.sideBarLabel,
            value: details?.addressName || '-',
          },
          {
            id: USER_DETAILS_MAPPER.email.key,
            type: 'email',
            title: USER_DETAILS_MAPPER.email.sideBarLabel,
            value: details?.email || '-',
            showCopyValue: true,
          },
          {
            id: USER_DETAILS_MAPPER.phoneNumber.key,
            type: 'tel',
            title: USER_DETAILS_MAPPER.phoneNumber.sideBarLabel,
            value: details?.phoneNumber || '-',
            showCopyValue: true,
          },
          {
            id: USER_DETAILS_MAPPER.dateOfBirth.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.dateOfBirth.sideBarLabel,
            value: details?.dateOfBirth || '-',
          },
          {
            id: USER_DETAILS_MAPPER.driversLicenseNumber.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.driversLicenseNumber.sideBarLabel,
            value: details?.driversLicenseNumber || '-',
          },
          {
            id: USER_DETAILS_MAPPER.driversLicenseIssueDate.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.driversLicenseIssueDate.sideBarLabel,
            value: details?.driversLicenseIssueDate || '-',
          },
          {
            id: USER_DETAILS_MAPPER.lang.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.lang.sideBarLabel,
            value:
              USER_DETAILS_MAPPER.lang.options.find(
                (option) => option.value === details?.lang
              )?.label || '-',
          },
          {
            id: USER_DETAILS_MAPPER.createdAt.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.createdAt.sideBarLabel,
            value: details?.createdAt || '-',
          },
          {
            id: USER_DETAILS_MAPPER.updatedAt.key,
            type: 'text',
            title: USER_DETAILS_MAPPER.updatedAt.sideBarLabel,
            value: details?.updatedAt || '-',
          },
        ],
      },
    ],
    [details] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <InstaTaskSideBar
      icon={<PersonIcon fontSize="small" />}
      sections={sidebarSections}
    />
  );
};

export default UserDetailsSidebar;
